module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_10000_50000.c5c3fa6f.png";